const INITIAL_STATE = {
  logList: {},
  log: {},
  errors: {},
}
  
const callLog = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_CALL_LOG':
    return { ...state, ...INITIAL_STATE, logList: action.data }
  case 'GET_CALL_LOG_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'ADD_CALL_LOG':
    return { ...state, ...INITIAL_STATE, log: action.data }
  case 'ADD_CALL_LOG_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data}
  case 'UPDATE_CALL_LOG':
    return { ...state, ...INITIAL_STATE, log: action.data }
  case 'UPDATE_CALL_LOG_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data}
  default:
    return { ...state }
  }
};
  
export default callLog;